import React, { useState, useEffect } from "react";
import { styled, useTheme } from "@mui/material/styles";
import { Link, useLocation } from "react-router-dom";

import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Logo from "../image/logo.png";
import List from "@mui/material/List";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ListItemButton from "@mui/material/ListItemButton";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import ConstructionIcon from "@mui/icons-material/Construction";
import ReceiptIcon from "@mui/icons-material/Receipt";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import LogoutIcon from "@mui/icons-material/Logout";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import RestorePageIcon from "@mui/icons-material/RestorePage";
import ManageHistoryIcon from "@mui/icons-material/ManageHistory";
import InfoIcon from "@mui/icons-material/Info";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import MapsHomeWorkIcon from "@mui/icons-material/MapsHomeWork";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import FeedIcon from "@mui/icons-material/Feed";
import AssignmentIcon from "@mui/icons-material/Assignment";
import TocIcon from "@mui/icons-material/Toc";
import GroupIcon from "@mui/icons-material/Group";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import BuildIcon from "@mui/icons-material/Build";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import Collapse from "@mui/material/Collapse";
import { FaFileInvoiceDollar } from "react-icons/fa";
import { LiaFileInvoiceSolid } from "react-icons/lia";

import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ChecklistRtlIcon from "@mui/icons-material/ChecklistRtl";
import { useNavigate } from "react-router-dom";
import { useIdleTimer } from "react-idle-timer";
import {
  Box,
  Divider,
  Grid,
  Modal,
  Popover,
  SwipeableDrawer,
  Switch,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Badge } from "react-bootstrap";
import { BASE_URL, DISABLED_MODULE } from "./../../global";
import { NotificationList } from "../notification/Notification";
import ResetPassword from "../resetPassword/resetPassword";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "white",
    "& .MuiToolbar-root": {
      color: "grey",
      "&:hover": {
        color: "black",
      },
    },
  },
  drawer: {
    // width: drawerWidth,
    flexShrink: 0,
    backgroundColor: "#fff",
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: "#fff",
  },
  listItem: {
    color: "#637381",
    fontWeight: "600",
    "&:hover": {
      backgroundColor: "#fff",
      // color: "white",
    },
  },
  selectedListItem: {
    backgroundColor: "white",
    color: "grey",
  },
}));

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(9)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function Navbar(props) {
  const navigate = useNavigate();
  const theme = useTheme();
  const [open, setOpen] = React.useState(true);
  const [resposiveAnchor, setResposiveAnchor] = React.useState({
    left: false,
  });
  const [dropDown, setDropDown] = useState(null);
  const [masterNested, setMasterNested] = React.useState(false);
  const [reportsNested, setReportsNested] = React.useState(false);
  const [reports2Nested, setReports2Nested] = React.useState(false);
  const [sagarReportsNested, setSagarReportsNested] = React.useState(false);
  const [transactionControlNested, setTransactionControlNested] =
    React.useState(false);
  const classes = useStyles();
  const userName = localStorage.getItem("userName");
  const userType = localStorage.getItem("type");
  const modules = localStorage.getItem("modules")?.split(",");
  const [isModalOpen, setModalOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width: 600px)");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [notificationsNo, setNotificationsNo] = React.useState(0);
  const location = useLocation();
  const pathname = location.pathname;
  const routeSegments = pathname.split("/");
  let selectedRoute = routeSegments[1];
  if (routeSegments[1] === "master" && routeSegments.length > 1) {
    selectedRoute = routeSegments[2];
  }
  const convertToTitleCase = (str) => {
    return str
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str) => str.toUpperCase());
  };

  const selectedRouteInUpperCase = convertToTitleCase(selectedRoute);
  const open2 = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
    sessionStorage.setItem("SideBar", true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
    sessionStorage.setItem("SideBar", false);
  };
  const handleButtonClick = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const logout = () => {
    props.setIsLoggedIn(false);
    window.localStorage.clear();
    window.sessionStorage.clear();
    navigate("/");
    window.location.reload(false);
  };

  const handleClickDropDown = (event) => {
    setDropDown(event.currentTarget);
  };

  const onIdle = () => {
    logout();
  };

  const onActive = () => {};

  const onAction = () => {};

  useIdleTimer({
    onIdle,
    onActive,
    onAction,
    timeout: 15 * 60 * 1000,
    throttle: 250,
  });

  // -----------------------------------------------

  const [open1, setOpen1] = React.useState(false);
  const anchorRef = React.useRef(null);
  const storage_userName = localStorage.getItem("userName");
  const storage_userType = localStorage.getItem("type");
  const storage_modules = localStorage
    .getItem("modules")
    ?.split(",")
    .map((e) => e)
    .map((e) => Number(e));

  const hasAccessToModule = (key) => {
    key = Number(key);
    if (DISABLED_MODULE?.includes(key)) return false;
    if (`${storage_userType}` === "1") return true;
    else if (
      `${storage_userType}` == "3" ||
      `${storage_userType}` == "4" ||
      `${storage_userType}` == "2" ||
      `${storage_userType}` == "5"
    ) {
      if (storage_modules?.includes(key)) return true;
      else return false;
    } else {
      if ([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].includes(key))
        return true;
      else return false;
    }
  };

  const handleCloseDropDown = () => {
    setDropDown(null);
  };

  const toggleDrawer = (anchor, open) => (event) => {
    setResposiveAnchor({ ...resposiveAnchor, [anchor]: open });
  };

  const sidebarListItems = () => (
    <List
      className={classes.drawer}
      component="nav"
      aria-labelledby="nested-list-subheader"
    >
      <ListItemButton
        className={classes.listItem}
        component={Link}
        to="/dashboard"
        onClick={() => {}}
      >
        <ListItemIcon className={classes.listItem}>
          <DashboardIcon />
        </ListItemIcon>
        {!isMobile ? (
          <ListItemText
            primary={<span style={{ fontWeight: "600" }}>Dashboard</span>}
          />
        ) : (
          <Typography
            variant="p"
            component="div"
            align="left"
            fontWeight="bold"
          >
            {"Dashboard"}
          </Typography>
        )}
      </ListItemButton>

      {hasAccessToModule("2") && !DISABLED_MODULE?.includes("Masters") && (
        <ListItemButton
          // component={Link}
          // to="/standardInOutList"

          className={classes.listItem}
          onClick={(e) => setMasterNested(!masterNested)}
        >
          <ListItemIcon className={classes.listItem}>
            <Tooltip title="Masters" arrow placement="right">
              <FormatListBulletedIcon />
            </Tooltip>
          </ListItemIcon>
          {!isMobile ? (
            <ListItemText
              primary={<span style={{ fontWeight: "600" }}>Masters</span>}
              className={classes.listItem}
            />
          ) : (
            <ListItemText className={classes.listItem}>
              <Typography
                variant="p"
                component="div"
                align="left"
                style={{ fontSize: "14px" }}
              >
                {"Masters"}
              </Typography>
            </ListItemText>
          )}
          {masterNested ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      )}
      <Collapse in={masterNested} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {hasAccessToModule(3) && !DISABLED_MODULE?.includes("circleList") && (
            <ListItemButton
              className={classes.listItem}
              sx={{ pl: 4 }}
              component={Link}
              to="/circleList"
              onClick={() => {}}
            >
              <ListItemIcon className={classes.listItem}>
                <ReceiptLongIcon />
              </ListItemIcon>
              {!isMobile ? (
                <ListItemText
                  primary={<span style={{ fontWeight: "600" }}>Circles</span>}
                />
              ) : (
                <Typography
                  variant="p"
                  component="div"
                  align="left"
                  fontWeight="bold"
                >
                  {"Circles"}
                </Typography>
              )}
            </ListItemButton>
          )}

          {hasAccessToModule(4) &&
            !DISABLED_MODULE?.includes("transformerTypeList") && (
              <ListItemButton
                className={classes.listItem}
                sx={{ pl: 4 }}
                component={Link}
                to="/transformerTypeList"
                onClick={() => {}}
              >
                <ListItemIcon className={classes.listItem}>
                  <ReceiptLongIcon />
                </ListItemIcon>
                {!isMobile ? (
                  <ListItemText
                    primary={
                      <span style={{ fontWeight: "600" }}>
                        Transformer Type
                      </span>
                    }
                  />
                ) : (
                  <Typography
                    variant="p"
                    component="div"
                    align="left"
                    fontWeight="bold"
                  >
                    {"Transformer Type"}
                  </Typography>
                )}
              </ListItemButton>
            )}

          {hasAccessToModule(5) && !DISABLED_MODULE?.includes("partList") && (
            <ListItemButton
              sx={{ pl: 4 }}
              className={classes.listItem}
              component={Link}
              to="/partList"
              onClick={() => {}}
            >
              <ListItemIcon className={classes.listItem}>
                <BuildIcon />
              </ListItemIcon>
              {!isMobile ? (
                <ListItemText
                  primary={<span style={{ fontWeight: "600" }}>Parts</span>}
                />
              ) : (
                <Typography
                  variant="p"
                  component="div"
                  align="left"
                  fontWeight="bold"
                >
                  {"Parts"}
                </Typography>
              )}
            </ListItemButton>
          )}

          {hasAccessToModule(6) &&
            !DISABLED_MODULE?.includes("serviceList") && (
              <ListItemButton
                sx={{ pl: 4 }}
                className={classes.listItem}
                component={Link}
                to="/serviceList"
                onClick={() => {}}
              >
                <ListItemIcon className={classes.listItem}>
                  <AcUnitIcon />
                </ListItemIcon>
                {!isMobile ? (
                  <ListItemText
                    primary={
                      <span style={{ fontWeight: "600" }}>Part&Service</span>
                    }
                  />
                ) : (
                  <Typography
                    variant="p"
                    component="div"
                    align="left"
                    fontWeight="bold"
                  >
                    {"Part&Service"}
                  </Typography>
                )}
              </ListItemButton>
            )}

          {hasAccessToModule(7) &&
            !DISABLED_MODULE?.includes("weightAndDeductionList") && (
              <ListItemButton
                sx={{ pl: 4 }}
                className={classes.listItem}
                component={Link}
                to="/weightAndDeductionList"
                onClick={() => {}}
              >
                <ListItemIcon className={classes.listItem}>
                  <RestorePageIcon />
                </ListItemIcon>
                {!isMobile ? (
                  <ListItemText
                    primary={
                      <span style={{ fontWeight: "600" }}>
                        Weight & Deduction
                      </span>
                    }
                  />
                ) : (
                  <Typography
                    variant="p"
                    component="div"
                    align="left"
                    fontWeight="bold"
                  >
                    {"Weight & Deduction"}
                  </Typography>
                )}
              </ListItemButton>
            )}
        </List>
      </Collapse>

      {hasAccessToModule("11") &&
        !DISABLED_MODULE?.includes("Transaction Control") && (
          <ListItemButton
            className={classes.listItem}
            onClick={(e) =>
              setTransactionControlNested(!transactionControlNested)
            }
          >
            <ListItemIcon className={classes.listItem}>
              <Tooltip title="Transaction Control" arrow placement="right">
                <FormatListBulletedIcon />
              </Tooltip>
            </ListItemIcon>
            {!isMobile ? (
              <ListItemText
                primary={
                  <span style={{ fontWeight: "600" }}>Transaction Control</span>
                }
              />
            ) : (
              <ListItemText>
                <Typography
                  variant="p"
                  component="div"
                  align="left"
                  style={{ fontSize: "14px" }}
                >
                  {"Transaction Control"}
                </Typography>
              </ListItemText>
            )}
            {transactionControlNested ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
        )}
      <Collapse in={transactionControlNested} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {hasAccessToModule("12") &&
            !DISABLED_MODULE?.includes("About L O T") && (
              <ListItemButton
                className={classes.listItem}
                sx={{ pl: 4 }}
                component={Link}
                to="/transactionControlList"
              >
                <ListItemIcon className={classes.listItem}>
                  <Tooltip title="About L O T" arrow placement="right">
                    <BookmarkIcon />
                  </Tooltip>
                </ListItemIcon>
                {!isMobile ? (
                  <ListItemText
                    primary={
                      <span style={{ fontWeight: "600" }}>About L O T</span>
                    }
                  />
                ) : (
                  <Typography variant="p" component="div" align="left">
                    {"About L O T"}
                  </Typography>
                )}
              </ListItemButton>
            )}

          {hasAccessToModule("13") &&
            !DISABLED_MODULE?.includes("Estimate") && (
              <ListItemButton
                className={classes.listItem}
                sx={{ pl: 4 }}
                component={Link}
                to="/estimate"
              >
                <ListItemIcon className={classes.listItem}>
                  <Tooltip title="Estimate" arrow placement="right">
                    <BookmarkIcon />
                  </Tooltip>
                </ListItemIcon>
                {!isMobile ? (
                  <ListItemText
                    primary={
                      <span style={{ fontWeight: "600" }}>Estimate</span>
                    }
                  />
                ) : (
                  <Typography variant="p" component="div" align="left">
                    {"Estimate"}
                  </Typography>
                )}
              </ListItemButton>
            )}
          {hasAccessToModule("0") &&
            !DISABLED_MODULE?.includes("GST Rate & Scrap") && (
              <ListItemButton
                className={classes.listItem}
                sx={{ pl: 4 }}
                // onClick={()=>clearSearchFilterSessionStorage("/historyCard")}
              >
                <ListItemIcon className={classes.listItem}>
                  <Tooltip title="GST Rate & Scrap" arrow placement="right">
                    <BookmarkIcon />
                  </Tooltip>
                </ListItemIcon>
                {!isMobile ? (
                  <ListItemText
                    primary={
                      <span style={{ fontWeight: "600" }}>
                        GST Rate & Scrap
                      </span>
                    }
                  />
                ) : (
                  <Typography variant="p" component="div" align="left">
                    {"GST Rate & Scrap"}
                  </Typography>
                )}
              </ListItemButton>
            )}
          {hasAccessToModule("0") &&
            !DISABLED_MODULE?.includes("Joint Sheet") && (
              <ListItemButton
                className={classes.listItem}
                sx={{ pl: 4 }}
                // onClick={()=>clearSearchFilterSessionStorage("/workReport")}
              >
                <ListItemIcon className={classes.listItem}>
                  <Tooltip title="Joint Sheet" arrow placement="right">
                    <ReceiptIcon />
                  </Tooltip>
                </ListItemIcon>
                {!isMobile ? (
                  <ListItemText
                    primary={
                      <span style={{ fontWeight: "600" }}>Joint Sheet</span>
                    }
                  />
                ) : (
                  <Typography variant="p" component="div" align="left">
                    {"Joint Sheet"}
                  </Typography>
                )}
              </ListItemButton>
            )}

          {hasAccessToModule("0") && !DISABLED_MODULE?.includes("Estimate") && (
            <ListItemButton
              className={classes.listItem}
              sx={{ pl: 4 }}
              // onClick={()=>clearSearchFilterSessionStorage("/wcrReport")}
            >
              <ListItemIcon className={classes.listItem}>
                <Tooltip title="Estimate" arrow placement="right">
                  <BookmarkIcon />
                </Tooltip>
              </ListItemIcon>
              {!isMobile ? (
                <ListItemText
                  primary={<span style={{ fontWeight: "600" }}>Estimate</span>}
                />
              ) : (
                <Typography variant="p" component="div" align="left">
                  {"Estimate"}
                </Typography>
              )}
            </ListItemButton>
          )}
        </List>
      </Collapse>

      {hasAccessToModule("14") && !DISABLED_MODULE?.includes("Reports") && (
        <ListItemButton
          className={classes.listItem}
          onClick={(e) => setReportsNested(!reportsNested)}
        >
          <ListItemIcon className={classes.listItem}>
            <Tooltip title="Reports" arrow placement="right">
              <FormatListBulletedIcon />
            </Tooltip>
          </ListItemIcon>
          {!isMobile ? (
            <ListItemText
              primary={<span style={{ fontWeight: "600" }}>Reports</span>}
            />
          ) : (
            <ListItemText>
              <Typography
                variant="p"
                component="div"
                align="left"
                style={{ fontSize: "14px" }}
              >
                {"Reports"}
              </Typography>
            </ListItemText>
          )}
          {reportsNested ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      )}
      <Collapse in={reportsNested} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {hasAccessToModule("15") &&
            !DISABLED_MODULE?.includes("Joint Inspection") && (
              <ListItemButton
                className={classes.listItem}
                sx={{ pl: 4 }}
                component={Link}
                to="/joinInspection"
              >
                <ListItemIcon className={classes.listItem}>
                  <Tooltip title="Joint Inspection" arrow placement="right">
                    <BookmarkIcon />
                  </Tooltip>
                </ListItemIcon>
                {!isMobile ? (
                  <ListItemText
                    primary={
                      <span style={{ fontWeight: "600" }}>
                        Joint Inspection
                      </span>
                    }
                  />
                ) : (
                  <Typography variant="p" component="div" align="left">
                    {"Joint Inspection"}
                  </Typography>
                )}
              </ListItemButton>
            )}
          {hasAccessToModule("16") &&
            !DISABLED_MODULE?.includes("Estimate") && (
              <ListItemButton
                className={classes.listItem}
                sx={{ pl: 4 }}
                component={Link}
                to="/estimateReport"
              >
                <ListItemIcon className={classes.listItem}>
                  <Tooltip title="Estimate" arrow placement="right">
                    <BookmarkIcon />
                  </Tooltip>
                </ListItemIcon>
                {!isMobile ? (
                  <ListItemText
                    primary={
                      <span style={{ fontWeight: "600" }}>Estimate</span>
                    }
                  />
                ) : (
                  <Typography variant="p" component="div" align="left">
                    {"Estimate"}
                  </Typography>
                )}
              </ListItemButton>
            )}

          {hasAccessToModule("10") &&
            !DISABLED_MODULE?.includes("Gagar Mei Sagar") && (
              <ListItemButton
                className={classes.listItem}
                onClick={(e) => setSagarReportsNested(!sagarReportsNested)}
              >
                <ListItemIcon className={classes.listItem}>
                  <Tooltip title="Gagar Mei Sagar" arrow placement="right">
                    <FormatListBulletedIcon />
                  </Tooltip>
                </ListItemIcon>
                {!isMobile ? (
                  <ListItemText
                    primary={
                      <span style={{ fontWeight: "600" }}>Gagar Mei Sagar</span>
                    }
                  />
                ) : (
                  <ListItemText>
                    <Typography
                      variant="p"
                      component="div"
                      align="left"
                      style={{ fontSize: "14px" }}
                    >
                      {"Gagar Mei Sagar"}
                    </Typography>
                  </ListItemText>
                )}
                {sagarReportsNested ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
            )}

          <Collapse in={sagarReportsNested} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {hasAccessToModule("15") &&
                !DISABLED_MODULE?.includes("Part 1") && (
                  <ListItemButton
                    className={classes.listItem}
                    sx={{ pl: 4 }}
                    component={Link}
                    to="/part1"
                  >
                    <ListItemIcon className={classes.listItem}>
                      <Tooltip title="Part 1" arrow placement="right">
                        <BookmarkIcon />
                      </Tooltip>
                    </ListItemIcon>
                    {!isMobile ? (
                      <ListItemText
                        primary={
                          <span style={{ fontWeight: "600" }}>Part 1</span>
                        }
                      />
                    ) : (
                      <Typography variant="p" component="div" align="left">
                        {"Part 1"}
                      </Typography>
                    )}
                  </ListItemButton>
                )}
              {hasAccessToModule("16") &&
                !DISABLED_MODULE?.includes("Part 2") && (
                  <ListItemButton
                    className={classes.listItem}
                    sx={{ pl: 4 }}
                    component={Link}
                    to="/part2"
                  >
                    <ListItemIcon className={classes.listItem}>
                      <Tooltip title="Part 2" arrow placement="right">
                        <BookmarkIcon />
                      </Tooltip>
                    </ListItemIcon>
                    {!isMobile ? (
                      <ListItemText
                        primary={
                          <span style={{ fontWeight: "600" }}>Part 2</span>
                        }
                      />
                    ) : (
                      <Typography variant="p" component="div" align="left">
                        {"Part 2"}
                      </Typography>
                    )}
                  </ListItemButton>
                )}

              {hasAccessToModule("17") &&
                !DISABLED_MODULE?.includes("Part 3") && (
                  <ListItemButton
                    className={classes.listItem}
                    sx={{ pl: 4 }}
                    component={Link}
                    to="/part3"
                  >
                    <ListItemIcon className={classes.listItem}>
                      <Tooltip title="Part 3" arrow placement="right">
                        <ReceiptIcon />
                      </Tooltip>
                    </ListItemIcon>
                    {!isMobile ? (
                      <ListItemText
                        primary={
                          <span style={{ fontWeight: "600" }}>Part 3</span>
                        }
                      />
                    ) : (
                      <Typography variant="p" component="div" align="left">
                        {"Part 3"}
                      </Typography>
                    )}
                  </ListItemButton>
                )}

              {hasAccessToModule("18") &&
                !DISABLED_MODULE?.includes("Part 4") && (
                  <ListItemButton
                    className={classes.listItem}
                    sx={{ pl: 4 }}
                    component={Link}
                    to="/part4"
                  >
                    <ListItemIcon className={classes.listItem}>
                      <Tooltip title="Part 4" arrow placement="right">
                        <BookmarkIcon />
                      </Tooltip>
                    </ListItemIcon>
                    {!isMobile ? (
                      <ListItemText
                        primary={
                          <span style={{ fontWeight: "600" }}>Part 4</span>
                        }
                      />
                    ) : (
                      <Typography variant="p" component="div" align="left">
                        {"Part 4"}
                      </Typography>
                    )}
                  </ListItemButton>
                )}
            </List>
          </Collapse>

          {hasAccessToModule("17") &&
            !DISABLED_MODULE?.includes("Annexure A") && (
              <ListItemButton
                className={classes.listItem}
                sx={{ pl: 4 }}
                component={Link}
                to="/annexure_A"
              >
                <ListItemIcon className={classes.listItem}>
                  <Tooltip title="Annexure A" arrow placement="right">
                    <ReceiptIcon />
                  </Tooltip>
                </ListItemIcon>
                {!isMobile ? (
                  <ListItemText
                    primary={
                      <span style={{ fontWeight: "600" }}>Annexure A</span>
                    }
                  />
                ) : (
                  <Typography variant="p" component="div" align="left">
                    {"Annexure A"}
                  </Typography>
                )}
              </ListItemButton>
            )}

          {hasAccessToModule("18") &&
            !DISABLED_MODULE?.includes("Annexure B") && (
              <ListItemButton
                className={classes.listItem}
                sx={{ pl: 4 }}
                component={Link}
                to="/annexure_B"
              >
                <ListItemIcon className={classes.listItem}>
                  <Tooltip title="Annexure B" arrow placement="right">
                    <BookmarkIcon />
                  </Tooltip>
                </ListItemIcon>
                {!isMobile ? (
                  <ListItemText
                    primary={
                      <span style={{ fontWeight: "600" }}>Annexure B</span>
                    }
                  />
                ) : (
                  <Typography variant="p" component="div" align="left">
                    {"Annexure B"}
                  </Typography>
                )}
              </ListItemButton>
            )}

          {hasAccessToModule("37") &&
            !DISABLED_MODULE?.includes("Work Order") && (
              <ListItemButton
                className={classes.listItem}
                sx={{ pl: 4 }}
                // onClick={()=>clearSearchFilterSessionStorage("/deptAnalyticsReport")}
              >
                <ListItemIcon className={classes.listItem}>
                  <Tooltip title="Work Order" arrow placement="right">
                    <BookmarkIcon />
                  </Tooltip>
                </ListItemIcon>
                {!isMobile ? (
                  <ListItemText primary={"Work Order"} />
                ) : (
                  <Typography variant="p" component="div" align="left">
                    {"Work Order"}
                  </Typography>
                )}
              </ListItemButton>
            )}

          {hasAccessToModule("37") &&
            !DISABLED_MODULE?.includes("Blank Join Inspection") && (
              <ListItemButton
                className={classes.listItem}
                sx={{ pl: 4 }}
                // onClick={()=>clearSearchFilterSessionStorage("/deptAnalyticsReport")}
              >
                <ListItemIcon className={classes.listItem}>
                  <Tooltip
                    title="Blank Join Inspection"
                    arrow
                    placement="right"
                  >
                    <BookmarkIcon />
                  </Tooltip>
                </ListItemIcon>
                {!isMobile ? (
                  <ListItemText primary={"Blank Join Inspection"} />
                ) : (
                  <Typography variant="p" component="div" align="left">
                    {"Blank Join Inspection"}
                  </Typography>
                )}
              </ListItemButton>
            )}
        </List>
      </Collapse>

      {hasAccessToModule("14") &&
        !DISABLED_MODULE?.includes("Reports_Set2") && (
          <ListItemButton
            className={classes.listItem}
            onClick={(e) => setReports2Nested(!reportsNested)}
          >
            <ListItemIcon className={classes.listItem}>
              <Tooltip title="Reports" arrow placement="right">
                <FormatListBulletedIcon />
              </Tooltip>
            </ListItemIcon>
            {!isMobile ? (
              <ListItemText
                primary={
                  <span style={{ fontWeight: "600" }}>Reports_Set2</span>
                }
              />
            ) : (
              <ListItemText>
                <Typography
                  variant="p"
                  component="div"
                  align="left"
                  style={{ fontSize: "14px" }}
                >
                  {"Reports_Set2"}
                </Typography>
              </ListItemText>
            )}
            {reports2Nested ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
        )}
      <Collapse in={reports2Nested} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {hasAccessToModule("19") &&
            !DISABLED_MODULE?.includes("Offer Letter") && (
              <ListItemButton
                className={classes.listItem}
                sx={{ pl: 4 }}
                component={Link}
                to="/offerLetterPDF"
              >
                <ListItemIcon className={classes.listItem}>
                  <Tooltip title="Offer Letter" arrow placement="right">
                    <BookmarkIcon />
                  </Tooltip>
                </ListItemIcon>
                {!isMobile ? (
                  <ListItemText
                    primary={
                      <span style={{ fontWeight: "600" }}>Offer Letter</span>
                    }
                  />
                ) : (
                  <Typography variant="p" component="div" align="left">
                    {"Offer Letter"}
                  </Typography>
                )}
              </ListItemButton>
            )}

          {hasAccessToModule("20") &&
            !DISABLED_MODULE?.includes("Oil Filling") && (
              <ListItemButton
                className={classes.listItem}
                sx={{ pl: 4 }}
                component={Link}
                to="/oilFilling"
              >
                <ListItemIcon className={classes.listItem}>
                  <Tooltip title="Oil Filling" arrow placement="right">
                    <BookmarkIcon />
                  </Tooltip>
                </ListItemIcon>
                {!isMobile ? (
                  <ListItemText
                    primary={
                      <span style={{ fontWeight: "600" }}>Oil Filling</span>
                    }
                  />
                ) : (
                  <Typography variant="p" component="div" align="left">
                    {"Oil Filling"}
                  </Typography>
                )}
              </ListItemButton>
            )}

          {hasAccessToModule("23") && !DISABLED_MODULE?.includes("Form9") && (
            <ListItemButton
              className={classes.listItem}
              sx={{ pl: 4 }}
              component={Link}
              to="/form9"
            >
              <ListItemIcon className={classes.listItem}>
                <Tooltip title="Form9" arrow placement="right">
                  <ReceiptIcon />
                </Tooltip>
              </ListItemIcon>
              {!isMobile ? (
                <ListItemText
                  primary={<span style={{ fontWeight: "600" }}>Form9</span>}
                />
              ) : (
                <Typography variant="p" component="div" align="left">
                  {"Form9"}
                </Typography>
              )}
            </ListItemButton>
          )}

          {/* {hasAccessToModule("21") &&
            !DISABLED_MODULE?.includes("Test Result") && (
              <ListItemButton
                className={classes.listItem}
                sx={{ pl: 4 }}
                component={Link}
                to="/testResult"
              >
                <ListItemIcon className={classes.listItem}>
                  <Tooltip title="Test Result" arrow placement="right">
                    <BookmarkIcon />
                  </Tooltip>
                </ListItemIcon>
                {!isMobile ? (
                  <ListItemText
                    primary={
                      <span style={{ fontWeight: "600" }}>Test Result</span>
                    }
                  />
                ) : (
                  <Typography variant="p" component="div" align="left">
                    {"Test Result"}
                  </Typography>
                )}
              </ListItemButton>
            )} */}
        </List>
      </Collapse>

          {hasAccessToModule(24) && !DISABLED_MODULE?.includes("Challan") && (
        <ListItemButton
          className={classes.listItem}
          component={Link}
          to="/challan"
          onClick={() => {}}
        >
          <ListItemIcon className={classes.listItem}>
           <LiaFileInvoiceSolid />
          </ListItemIcon>
          {!isMobile ? (
            <ListItemText
              primary={<span style={{ fontWeight: "600" }}>Challan</span>}
            />
          ) : (
            <Typography
              variant="p"
              component="div"
              align="left"
              fontWeight="bold"
            >
              {"Challan"}
            </Typography>
          )}
        </ListItemButton>
      )}

            {hasAccessToModule(25) && !DISABLED_MODULE?.includes("InvoiceReport") && (
        <ListItemButton
          className={classes.listItem}
          component={Link}
          to="/invoice"
          onClick={() => {}}
        >
          <ListItemIcon className={classes.listItem}>
         <FaFileInvoiceDollar />
          </ListItemIcon>
          {!isMobile ? (
            <ListItemText
              primary={<span style={{ fontWeight: "600" }}>InvoiceReport</span>}
            />
          ) : (
            <Typography
              variant="p"
              component="div"
              align="left"
              fontWeight="bold"
            >
              {"InvoiceReport"}
            </Typography>
          )}
        </ListItemButton>
      )}

      {hasAccessToModule(8) && !DISABLED_MODULE?.includes("Clients") && (
        <ListItemButton
          className={classes.listItem}
          component={Link}
          to="/clientsList"
          onClick={() => {}}
        >
          <ListItemIcon className={classes.listItem}>
            <GroupIcon />
          </ListItemIcon>
          {!isMobile ? (
            <ListItemText
              primary={<span style={{ fontWeight: "600" }}>Clients</span>}
            />
          ) : (
            <Typography
              variant="p"
              component="div"
              align="left"
              fontWeight="bold"
            >
              {"Clients"}
            </Typography>
          )}
        </ListItemButton>
      )}

      {hasAccessToModule(9) && !DISABLED_MODULE?.includes("Users") && (
        <ListItemButton
          className={classes.listItem}
          component={Link}
          to="/usersList"
          onClick={() => {}}
        >
          <ListItemIcon className={classes.listItem}>
            <GroupIcon />
          </ListItemIcon>
          {!isMobile ? (
            <ListItemText
              primary={<span style={{ fontWeight: "600" }}>Users</span>}
            />
          ) : (
            <Typography
              variant="p"
              component="div"
              align="left"
              fontWeight="bold"
            >
              {"Users"}
            </Typography>
          )}
        </ListItemButton>
      )}
      {isMobile && (
        <>
          <Divider
            sx={{
              backgroundColor: "black",
              height: "2px",
            }}
          />
          <ListItemButton>
            <ListItemIcon>
              <Tooltip title="Notification" arrow placement="right">
                <IconButton
                  // onClick={handleClick2}
                  size="small"
                  sx={{ height: "27px", width: "27px" }}
                  aria-controls={open2 ? "Role" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open2 ? "true" : undefined}
                  style={{ backgroundColor: "white", marginRight: "5px" }}
                  disabled
                >
                  <AccountCircleIcon style={{ color: "#1976d2" }} />
                </IconButton>
              </Tooltip>
            </ListItemIcon>
            <Tooltip title="User (User Type)" style={{}}>
              <Typography
                variant="p"
                component="div"
                align="left"
                sx={{ fontSize: "90%" }}
              >
                {userName}
                <span style={{}}>
                  ({["Admin", "ENGINEER", "Client"][userType - 1]})
                </span>
              </Typography>
            </Tooltip>
          </ListItemButton>
          <ResetPassword isMobile={isMobile} />
          <ListItemButton>
            <ListItemIcon>
              <Tooltip title="Logout" arrow placement="right">
                <ExitToAppIcon />
              </Tooltip>
            </ListItemIcon>
            <Typography
              variant="p"
              component="div"
              align="left"
              onClick={logout}
            >
              {"Logout"}
            </Typography>
          </ListItemButton>
          <ListItemButton>
            <ListItemIcon>
              <Tooltip title="info" arrow placement="right">
                <InfoIcon />
              </Tooltip>
            </ListItemIcon>
            <Typography variant="p" component="div" align="left">
              {"TPI Software Version 2.0.0"}
            </Typography>
          </ListItemButton>
        </>
      )}
    </List>
  );

  const MobileList = (anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <DrawerHeader>
        <Typography variant="h6" gutterBottom component="div">
          Calibration
        </Typography>
        <IconButton onClick={handleDrawerClose}>
          {theme.direction === "rtl" ? (
            <ChevronRightIcon />
          ) : (
            <ChevronLeftIcon />
          )}
        </IconButton>
      </DrawerHeader>
      {sidebarListItems()}
    </Box>
  );

  const handleDrawerToggle = () => {
    if (isMobile) {
      setResposiveAnchor({ ...resposiveAnchor, left: !resposiveAnchor.left });
    } else {
      // handleDrawerOpen();
      setOpen(!open);
    }
  };

  React.useEffect(() => {
    if (isMobile) {
      setOpen(false);
    }
  }, [isMobile]);

  return (
    <>
      <CssBaseline />
      <AppBar position="fixed" open={open}>
        <Toolbar variant="dense" style={{ paddingRight: "5px" }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerToggle}
            edge="start"
            sx={{
              marginRight: "5px",
              ...(!isMobile && open && { display: "none" }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1 }}
            align="left"
          >
            {selectedRouteInUpperCase}
          </Typography>
          {/* <Tooltip title="Notification">
            <IconButton
              onClick={handleClick}
              size="small"
              sx={{ ml: 2, mr: 1, height: "27px", width: "27px" }}
              aria-controls={open2 ? "available-roles" : undefined}
              aria-haspopup="true"
              aria-expanded={open2 ? "true" : undefined}
              style={{ backgroundColor: "white" }}
            >
              <Badge
                badgeStyle={{
                  top: 12,
                  right: 12,
                  backgroundColor: "white",
                  border: "2px solid black",
                  color: "white",
                  fontWright: 900,
                }}
                color="secondary"
                badgeContent={`${notificationsNo}`}
                secondary={true}
              >
                <NotificationsNoneIcon style={{ color: "#1976d2" }} />
              </Badge>
            </IconButton>
          </Tooltip> */}
          {/* <NotificationList
        anchorEl={anchorEl}
        open={open2}
        close={handleClose}
        notifyNumber={(n) => setNotificationsNo(n)}
        isMobile={isMobile}
      /> */}
          {!isMobile && (
            <>
              <Typography
                variant="p"
                component="div"
                align="left"
                sx={{ fontSize: "90%", cursor: "pointer" }}
                onClick={handleClickDropDown}
              >
                <AccountCircleIcon />
                &nbsp;
                {userName} &nbsp;
                <span style={{}}>
                  ({["Admin", "ENGINEER", "Client"][userType - 1]})
                </span>
              </Typography>
            </>
          )}
          <Modal
            open={isModalOpen}
            onClose={handleCloseModal}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              height: "100%",
            }}
          >
            <div
              style={{
                height: "24px",
                backgroundColor: "#fff",
                position: "fixed",
                top: "7%",
                right: "0px",
                width: "auto",
                textAlign: "right",
                boxSizing: "border-box",
                color: "#fff",
              }}
            >
              <span
                style={{
                  backgroundColor: "#000",
                  padding: "3px",
                }}
              >
                TPI Software version 2.0.0
              </span>
            </div>
          </Modal>
        </Toolbar>
      </AppBar>

      <Popover
        open={Boolean(dropDown)}
        anchorEl={dropDown}
        onClose={handleCloseDropDown}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div style={{ padding: "10px" }}>
          <Grid container direction="column" spacing={2}>
            {!isMobile && (
              <Grid item>
                <ResetPassword isMobile={isMobile} />
              </Grid>
            )}
            {!isMobile && (
              <Grid item>
                <Button onClick={logout}>
                  <LogoutIcon style={{ marginRight: "10px" }} />
                  Logout
                </Button>
              </Grid>
            )}
            {!isMobile && (
              <Grid item>
                <Button onClick={handleButtonClick}>
                  <InfoIcon style={{ marginRight: "10px" }} />
                  Info
                </Button>
              </Grid>
            )}
          </Grid>
        </div>
      </Popover>

      {!isMobile ? (
        <Drawer variant="permanent" open={open}>
          <DrawerHeader className={classes.drawer}>
            <img
              src={`${Logo}`}
              alt="logo"
              style={{
                fontFamily: "monospace",
                fontWeight: 700,
                letterSpacing: ".3rem",
                color: "inherit",
                textDecoration: "none",
                height: "100px",
                width: "100%",
                margin: "auto",
                textAlign: "center",
              }}
            />
            <IconButton
              sx={{ color: "#637381", fontWeight: "bold" }}
              onClick={handleDrawerClose}
            >
              {theme.direction === "rtl" ? (
                <ChevronRightIcon />
              ) : (
                <ChevronLeftIcon />
              )}
            </IconButton>
          </DrawerHeader>
          <Box
            sx={{
              height: "90vh",
            }}
            className={classes.drawer}
          >
            {sidebarListItems()}
          </Box>
        </Drawer>
      ) : null}

      <SwipeableDrawer
        anchor={"left"}
        open={resposiveAnchor["left"]}
        onClose={toggleDrawer("left", false)}
        onOpen={toggleDrawer("left", true)}
      >
        {MobileList("left")}
      </SwipeableDrawer>
    </>
  );
}
